module.exports = require("lodash/get");


//////////////////
// WEBPACK FOOTER
// external "lodash/get"
// module id = 38
// module chunks = 0